/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { ActivityLog } from '../types';
import { AuditRepository } from '../repositories/auditRepository';

export class AuditService {
  static async logOperation(
    usuario: string,
    modulo: string,
    accion: string,
    detalles: string,
    companyId?: string,
    nombreEmpresa?: string,
    correlationId?: string
  ): Promise<ActivityLog> {
    return AuditRepository.recordLog(
      usuario,
      modulo,
      accion,
      detalles,
      companyId || 'company-insumedic',
      nombreEmpresa || 'COMERCIALIZADORA INSUMEDIC S.A.S',
      correlationId
    );
  }
}
